module.exports = "<navbar-horizontal-style-1></navbar-horizontal-style-1>"